import { MutationFunction, MutationOptions, useMutation } from 'react-query';
import {
    CreateDailyTruckRideBody,
    DailyTruckRideResponse,
    UpdateDailyTruckRideBody,
    UpdateIncludedInExpensesBody,
    UpdateIncludedInExpensesResponse,
    createDailyTrucksRides,
    deleteDailyTrucksRides,
    updateDailyTrucksRides,
    updateIncludedInExpenses,
} from '../../services/apiSLTP/dailyReports/dailyTrucksRides';

type UseUpdateDailyTruckRideMutationOptions = MutationOptions<DailyTruckRideResponse, Error, { id: string; data: UpdateDailyTruckRideBody }>;

export const useUpdateDailyTruckRideMutation = (options?: UseUpdateDailyTruckRideMutationOptions) => {
    const DailyTruckRideMutation: MutationFunction<DailyTruckRideResponse, { id: string; data: UpdateDailyTruckRideBody }> = async ({ id, data }) => {
        try {
            const response: DailyTruckRideResponse = await updateDailyTrucksRides(id, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTruckRide');
        }
    };

    return useMutation(DailyTruckRideMutation, options);
};

type UseCreateDailyTruckRideMutationOptions = MutationOptions<DailyTruckRideResponse, Error, CreateDailyTruckRideBody>;

export const useCreateDailyTruckRideMutation = (options?: UseCreateDailyTruckRideMutationOptions) => {
    const DailyTruckRideMutation: MutationFunction<DailyTruckRideResponse, CreateDailyTruckRideBody> = async (data) => {
        try {
            const response: DailyTruckRideResponse = await createDailyTrucksRides(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTruckRide');
        }
    };

    return useMutation(DailyTruckRideMutation, options);
};

type UseDeleteDailyTruckRideMutationOptions = MutationOptions<DailyTruckRideResponse, Error, { id: string }>;

export const useDeleteDailyTruckRideMutation = (options?: UseDeleteDailyTruckRideMutationOptions) => {
    const DailyTruckRideMutation: MutationFunction<DailyTruckRideResponse, { id: string }> = async ({ id }) => {
        try {
            const response: DailyTruckRideResponse = await deleteDailyTrucksRides(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during DailyTruckRide');
        }
    };

    return useMutation(DailyTruckRideMutation, options);
};

type UseUpdateIncludedInExpensesMutationOptions = MutationOptions<UpdateIncludedInExpensesResponse, Error, UpdateIncludedInExpensesBody>;

export const useUpdateIncludedInExpensesMutation = (options?: UseUpdateIncludedInExpensesMutationOptions) => {
    const mutationFn: MutationFunction<UpdateIncludedInExpensesResponse, UpdateIncludedInExpensesBody> = async (data) => {
        try {
            const response: UpdateIncludedInExpensesResponse = await updateIncludedInExpenses(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during updateIncludedInExpenses');
        }
    };

    return useMutation(mutationFn, options);
};
